/**
 * 功能开关
 * 2026-08-26: 初一3班上线，测评功能暂不开放
 * 2026-09-23: 当前阶段只推成长记录，测评整条线收口。关闭时除了隐藏入口，
 *   路由也不再注册（见 App.tsx），避免直接敲 URL 绕进去。
 *   注意这是纯前端开关，server 端 /api/assessment* 仍然可用 —— 因为历史测评
 *   数据还在喂 StudentProfile 的能力雷达，后端一刀切会把那些页面打成 500。
 * 2026-09-23: AI 成长大脑整条线也收口。原因不是测评关了，而是它依赖的
 *   family_assessments 表 0 行 —— 家长一份问卷都没填，四个卡片里三个点进去是空页面。
 *   连带收口的三个教师子页面（家庭成长画像/教师指导系统/家庭资源地图）唯一入口
 *   就是成长大脑首页，所以必须一起关，否则会变成没有入口的死功能。
 *   代码全部保留，等家庭问卷真的发下去、有数据了把开关打开即可。
 * 2026-09-28: 家长端「成长画像」也收口，家长首页换成六宫格服务入口。
 *   根因是 ENABLE_ASSESSMENT=false 的连带后果，上线前在线上库点过数：
 *     - 成长指数/能力雷达/优势/待提升 → 空态 60/62 个家庭
 *     - AI 建议/AI 总结              → 空态 61/62 个家庭
 *   为什么关了测评这些就永远空：abilitySnapshot.js 的口径是「测评是基线，
 *   事件只是增量，没有基线就没有数值(null)」。成长记录永远不产生基线，
 *   所以测评一关，这 60 个家庭的雷达图再也不会有数 —— 不是"还没测"，是"不会再有"。
 */
export const FEATURE_FLAGS = {
  /** 测评功能（自适应测评 + 教师发布测评任务） */
  ENABLE_ASSESSMENT: false,
  /**
   * AI 成长大脑（含家庭成长画像、教师指导系统、家庭资源地图）。
   * ⚠️ 这个开关不控制家长端填问卷的入口（/home/family）——
   *   那条线是数据来源，关了就永远等不到数据。
   */
  ENABLE_GROWTH_BRAIN: false,
  /**
   * 家长端「成长画像」tab（/home/profile）+ 首页的成长内容区。
   *
   * 关闭时：底栏只剩「首页」「家校服务」两个 tab，首页 = 六宫格服务入口。
   * 打开时：底栏恢复三个 tab，首页 = 原来那套雷达图/AI建议/优势待提升。
   *
   * ⚠️ 跟 ENABLE_ASSESSMENT 是主从关系，不是两个独立开关：
   *   这个开关为 true 而 ENABLE_ASSESSMENT 为 false 时，页面能打开但内容是空的
   *   （数据源只认测评基线）。所以要开回来，**先开 ENABLE_ASSESSMENT**，
   *   或者先改掉 abilitySnapshot.js 让成长记录也能产生基线。
   * ⚠️ 同样不控制 /home/family（填问卷入口），理由见 ENABLE_GROWTH_BRAIN。
   * ⚠️ 也不控制教师端 StudentProfile 的能力雷达 —— 老师看的是全班对比，
   *   35 个老师里有人在用，那条线不受影响。
   */
  ENABLE_GROWTH_PROFILE: false,
};
